import { render, staticRenderFns } from "./AS_ProjectMobileDropDown.vue?vue&type=template&id=70cfdc32&scoped=true&"
import script from "./AS_ProjectMobileDropDown.vue?vue&type=script&lang=js&"
export * from "./AS_ProjectMobileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./AS_ProjectMobileDropDown.vue?vue&type=style&index=0&id=70cfdc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfdc32",
  null
  
)

export default component.exports